import type { IconSvgObject } from './types';

const Blockchain05Icon: IconSvgObject = [
  ["path", { d: "M18.5 5.5V12.5L12 16L5.5 12.5V5.5L12 2L18.5 5.5ZM5.5 5.5L12 9M12 16V9M18.5 5.5L12 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 20.5V22H14.5V20.5M9.5 20.5V19H14.5V20.5M9.5 20.5H5M14.5 20.5H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Blockchain05Icon;
